module.exports = __webpack_public_path__ + "img/help1.7b9cc4fd.png";